import type { ReactNode } from "react"
import { ArrowRight } from "lucide-react"
import { cn } from "@/lib/utils"
import { LogsTable, type LogsTableProps } from "../LogsTable/LogsTable"

export interface LogsPanelProps extends LogsTableProps {
  isEmpty?: boolean
  emptyLabel?: ReactNode
  className?: string
}

export function LogsPanel({
  isEmpty = false,
  emptyLabel,
  className,
  ...tableProps
}: LogsPanelProps) {
  if (isEmpty) {
    return (
      <div
        className={cn(
          "h-full flex items-center justify-center px-6",
          className,
        )}
      >
        <p className="text-caption text-muted-foreground text-center leading-relaxed">
          {emptyLabel ?? (
            <>
              Your strategy logs will live here.
            </>
          )}
        </p>
      </div>
    )
  }
  return <LogsTable className={className} {...tableProps} />
}
